import { Media } from '@form-builder/types'
import { Table, TableProps } from 'antd'

import { normalizeMediaList } from '../utils'

import { GetTableColumns } from './tableColumns'

type Props = {
  media?: Media[]
  selectedMedia?: Media
  onClick: (file: Media) => void
} & TableProps<Media>

export const FormMediaSelect = ({
  media = [],
  onClick,
  selectedMedia,
  pagination,
  ...props
}: Props) => {
  const columns = GetTableColumns()
  const data = normalizeMediaList(media)

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="id"
      scroll={{ x: true }}
      onRow={(record) => ({
        onClick: () => onClick(record)
      })}
      rowSelection={{
        type: 'radio',
        selectedRowKeys: [selectedMedia?.id || ''],
        onSelect: onClick
      }}
      pagination={{ ...pagination, showSizeChanger: false }}
      {...props}
    />
  )
}
